// Test Collection in Firestore
//const projectSource = "projects-dev";
const projectSource = "projects-prod";

export { projectSource as default };
